<template>
  <div :class="mgBtm" class="color-dark f-df">
    <h3 class="f-fwn f-fs16 f-df">
      <span>{{ title }}</span>
      <el-popover
        v-if='tipTxt'
        trigger="hover"
        placement="right-start"
        effect="light">
        <div class="f-lh22 f-fs14 tip-txt-box" v-html="tipTxt"></div>
        <i slot="reference" class="el-icon-question mg-left5 color-red-mark f-fs1 f-csp"></i>
      </el-popover>
    </h3>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String, // 类型
      default: '' // 默认值
    },
    tipTxt: {
      type: String, // 类型
      default: '通过获批产品数量的时间趋势变化情况，您可从中了解该企业注册产品的节奏。' // 默认值
    },
    mgBtm: {
      type: String, // 类型
      default: 'mg-btm30 f-jcsb' // 默认值
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.tip-txt-box{
  max-width: 400px;
}
</style>
